var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", [
    _c("div", { staticClass: "panel panel-grey" }, [
      _c("div", { staticClass: "panel-body" }, [
        _c("div", { staticClass: "form-horizontal" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "checkbox checkbox-primary col-sm-9" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.stateOpportunities,
                    expression: "stateOpportunities",
                  },
                ],
                attrs: {
                  type: "checkbox",
                  name: "opportunities[]",
                  id: `checkbox-opportunity-${_vm.opportunity.id}-${_vm.childOpportunity.id}`,
                },
                domProps: {
                  value: { id: _vm.childOpportunity.id },
                  checked: Array.isArray(_vm.stateOpportunities)
                    ? _vm._i(_vm.stateOpportunities, {
                        id: _vm.childOpportunity.id,
                      }) > -1
                    : _vm.stateOpportunities,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.stateOpportunities,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = { id: _vm.childOpportunity.id },
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.stateOpportunities = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.stateOpportunities = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.stateOpportunities = $$c
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  attrs: {
                    for: `checkbox-opportunity-${_vm.opportunity.id}-${_vm.childOpportunity.id}`,
                  },
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.childOpportunity.name) +
                      "\n            "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm.opportunitiesWithBudget.includes(
              _vm.childOpportunity.name.trim().toLowerCase()
            )
              ? _c("div", { staticClass: "col-sm-3" }, [
                  _c(
                    "div",
                    {
                      class: _vm.$hasErrorClass(
                        _vm.$v.stateOpportunityChildrenBudget,
                        "form-group"
                      ),
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.stateOpportunityChildrenBudget.$model,
                            expression:
                              "$v.stateOpportunityChildrenBudget.$model",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          disabled: "",
                          placeholder: "Budget",
                        },
                        domProps: {
                          value: _vm.$v.stateOpportunityChildrenBudget.$model,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.stateOpportunityChildrenBudget,
                              "$model",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("vuelidate-help", {
                        attrs: {
                          label: "Budget",
                          field: _vm.$v.stateOpportunityChildrenBudget,
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }